export default __webpack_public_path__ + "static/media/Cleaning-Chemicals-mob.774e4969.jpg";